import { Text } from '@shared/ui/antd';
import { Flex } from 'antd';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const NoSelectedDialog: FC = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'messages' });

  return (
    <Flex
      flex="1 1 0"
      gap={12}
      align="center"
      justify="center"
      style={{ height: '100%', width: '100%' }}
      vertical
    >
      <Text variant="xl" fontWeight={700} style={{ color: 'var(--color-text-secondary)' }}>
        {t('noSelectedDialog')}
      </Text>

      <Text variant="md" fontWeight={500} style={{ color: 'var(--color-text-secondary)' }}>
        {t('noSelectedDialogMessage')}
      </Text>
    </Flex>
  );
};
